import ConsentForms from './ConsentForms';

export default ConsentForms;
